// 葡萄牙语（巴西）
export default {}
